export default __webpack_public_path__ + "static/media/no-photo.d4be075f.svg";